const bookActions = {
  CREATE_BOOK: 'CREATE_BOOK',
  CREATE_BOOK_ENDED: 'CREATE_BOOK_ENDED',
  SEARCH_BOOKS: 'SEARCH_BOOKS',
  SEARCH_BOOKS_ENDED: 'SEARCH_BOOKS_ENDED',
  FIND_BOOK: 'FIND_BOOK',
  FIND_BOOK_ENDED: 'FIND_BOOK_ENDED',
  DELETE_BOOKS: 'DELETE_BOOKS',
  DELETE_BOOKS_ENDED: 'DELETE_BOOKS_ENDED',
  UPDATE_BOOK: 'UPDATE_BOOK',
  UPDATE_BOOK_ENDED: 'UPDATE_BOOK_ENDED',
  GET_MEDIA_TYPES: 'GET_MEDIA_TYPES',
  GET_MEDIA_TYPES_ENDED: 'GET_MEDIA_TYPES_ENDED',
  ARCHIVE_BOOKS: 'ARCHIVE_BOOKS',
  ARCHIVE_BOOKS_END: 'ARCHIVE_BOOKS_END',
};

export default bookActions;
